import { createAction } from "@reduxjs/toolkit";
import { Step } from "layout/models/step.model";

const enum LayoutReducer {
	setSteps = "[LAYOUT] Set Steps",
	updateStepsByService = "[LAYOUT] Update Steps by service",
	endStep = "[LAYOUT] End Step",
	setHighStep = "[LAYOUT] Set High Step",
	setCurrentPraticaState = "[LAYOUT] Set Current Pratica State",
}

export const layoutSetSteps = createAction<Step[]>(LayoutReducer.setSteps);

export const layoutUpdateStepsByService = createAction<string | undefined>(
	LayoutReducer.updateStepsByService
);

export const layoutSetHighStep = createAction<Step>(LayoutReducer.setHighStep);

export const layoutEndStep = createAction<boolean>(LayoutReducer.endStep);

export const layoutSetCurrentPraticaState = createAction<Step[]>(
	LayoutReducer.setCurrentPraticaState
);
